exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Zy2bmz0QVVxcrOkDKh6Ek {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.aMNEGEC0OFmMJ08KkpuMH {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--primary-text-color);\n  font-size: var(--font-size-normal);\n  cursor: pointer;\n}\n\n.aMNEGEC0OFmMJ08KkpuMH input {\n  accent-color: var(--primary-base-color);\n  margin: 0;\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"rotationOptions": "_3Zy2bmz0QVVxcrOkDKh6Ek",
	"radioLabel": "aMNEGEC0OFmMJ08KkpuMH"
};